<script lang="ts">
  import FeedbackButton from "./FeedbackButton.svelte";
  import { createEventDispatcher } from "svelte";

  let positiveClicked = false;
  let negativeClicked = false;

  const dispatch = createEventDispatcher<{
    feedbackClicked: { isPositive: boolean };
  }>();

  const handlePositiveFeedback = () => {
    // do nothing if already clicked
    if (positiveClicked) return;
    positiveClicked = true;

    if (negativeClicked) {
      negativeClicked = false;
    }

    dispatch("feedbackClicked", { isPositive: true });
  };

  const handleNegativeFeedback = () => {
    // do nothing if already clicked
    if (negativeClicked) return;
    negativeClicked = true;

    if (positiveClicked) {
      positiveClicked = false;
    }

    dispatch("feedbackClicked", { isPositive: false });
  };
</script>

<div class="flex w-fit items-center justify-center gap-2 p-2">
  <p class="mr-7 text-sm font-medium text-neutral-400">Was this doc helpful?</p>
  <FeedbackButton isPositive clicked={positiveClicked} on:click={handlePositiveFeedback} />
  <FeedbackButton isPositive={false} clicked={negativeClicked} on:click={handleNegativeFeedback} />
</div>
